import { MediaFileService } from './../../../../shared/services/media-file.service';
import { ISetting } from './../../../../_models/cms/ISetting';
import { IKeyValuePair } from './../../../../_models/common/common';
import { CommonService } from './../../../../shared/services/common.service';
import { SettingService } from './../../../../shared/services/setting.service';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-setting-form',
  templateUrl: './setting-form.component.html'
})
export class SettingFormComponent implements OnInit {

  loading: boolean;
  title: string = 'Add Setting';
  setting: ISetting;
  settingForm: FormGroup;
  id;

  financialYears: IKeyValuePair[];
  phases: IKeyValuePair[];

  barWidth: number = 0;
  isProgress: boolean = false;
  fileToUpload: File = null;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private toastrService: ToastrService,
    private service: SettingService,
    private commonService: CommonService,
    private mediaFileService: MediaFileService,) {
    this.id = this.route.snapshot.paramMap.get('id');
  }

  ngOnInit() {
    this.createSettingForm();
    this.bindDropDown();
    this.service.getSetting().then(data => {
      this.setting = data;
      console.log('Promise resolved.');
      this.setValueSettingForm();
    });
  }


  bindDropDown() { 
    this.commonService.getFinancialYears().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.financialYears = response;
      }
    });
    this.commonService.getPhases().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.phases = response;
      }
    });
  }

  createSettingForm() {
    this.settingForm = this.fb.group({
      id: ['0'],
      financialYearId: ['', [Validators.required]],
      phaseId: ['', [Validators.required]],
      isProfile: [false],
      isProfilePrincipal: [false],
      isProfileRO: [false],
      isTransfer: [false],
      isTransferPrincipal: [false],
      isTransferRO: [false],
      isVacancyRO: [false],
      isVacancyPrincipal: [false],
      isVacancyEmp: [false],
      isEmpLoginClose: [false],
      isROLoginClose: [false],
      isPrincipalLoginClose: [false],
      assiCommName: [''],
      assiCommSignId: [''],
      cutOfDate: ['', [Validators.required, Validators.pattern("[0-9]{2}[-][0-9]{2}[-][0-9]{4}")]],
      //previousYearCutOfDate: ['', [Validators.required, Validators.pattern("[0-9]{2}[-][0-9]{2}[-][0-9]{4}")]],
    });
  }

  setValueSettingForm() {
    this.settingForm.patchValue({
      id: this.setting.id,
      financialYearId: this.setting.financialYearId,
      phaseId: this.setting.phaseId,
      isProfile: this.setting.isProfile,
      isProfilePrincipal: this.setting.isProfilePrincipal,
      isProfileRO: this.setting.isProfileRO,
      isTransfer: this.setting.isTransfer,
      isTransferPrincipal: this.setting.isTransferPrincipal,
      isTransferRO: this.setting.isTransferRO,
      isVacancyRO: this.setting.isVacancyRO,
      isVacancyPrincipal: this.setting.isVacancyPrincipal,
      isVacancyEmp: this.setting.isVacancyEmp,
      isEmpLoginClose: this.setting.isEmpLoginClose,
      isROLoginClose: this.setting.isROLoginClose,
      isPrincipalLoginClose: this.setting.isPrincipalLoginClose,
      assiCommName: this.setting.assiCommName,
      assiCommSignId: this.setting.assiCommSignId,
      cutOfDate: this.datePipe.transform(this.setting.cutOfDate , 'dd-MM-yyyy'),
      //previousYearCutOfDate: this.datePipe.transform(this.setting.previousYearCutOfDate , 'dd-MM-yyyy'),
    });
  }

  save() {
    if (this.settingForm.valid) {
      this.loading = true;
      this.setting = Object.assign({}, this.settingForm.value);
      if (this.id) {
        this.service.update(this.id, this.setting).subscribe((response: ISetting) => {
          if (response) {
            this.setting.id = response.id;
            this.service.setSetting();
            this.toastrService.success('setting updated successful');
            this.router.navigate(['/admin/setting']);
          }
        },
          (error) => console.log('HTTP Error', error),
          () => this.loading = false);
      }
      else {
        this.service.create(this.setting).subscribe((response: ISetting) => {
          if (response) {
            this.setting.id = response.id;
            this.service.updateSetting();
            this.toastrService.success('setting created successful');
            this.router.navigate(['/admin/setting']);
          }
        },
          (error) => console.log('HTTP Error', error),
          () => this.loading = false);
      }
    }
  }


  handleFileInput(file: FileList) {
    this.fileToUpload = file.item(0);
  }

  OnSubmit(inputDoc) {

    this.mediaFileService.authPostSingleFile(this.fileToUpload).subscribe(
      (event: HttpEvent<any>) => {
        if (event.type === HttpEventType.UploadProgress) {
          this.isProgress = true;
          this.barWidth = Math.round(event.loaded / event.total * 100);
        }
        else if (event.type === HttpEventType.Response) {
          this.isProgress = false;
          this.barWidth = 0;
          this.settingForm.patchValue({
            assiCommSignId: event.body.id   
          });
        } 
      },
      (error) => {
        console.log(error);  
        inputDoc.value = null;            
      },
      () => console.log("complete"));                       
  }    

}
